import LocalizedClientLink from '@modules/common/components/localized-client-link';
import Thumbnail from '@modules/products/components/thumbnail';
import type { CartItemVM } from 'types/view-models';

type ItemThumbnailProps = {
  item: Pick<CartItemVM, 'product_handle' | 'thumbnail' | 'variant'>;
  className?: string;
};

export function ItemThumbnail({ item, className }: ItemThumbnailProps) {
  return (
    <LocalizedClientLink
      href={`/${item.product_handle}`}
      className={className}
      tabIndex={-1}
      aria-hidden="true"
    >
      <Thumbnail
        as="div"
        thumbnail={item.thumbnail}
        images={item.variant?.product?.images}
        className="shadow-none rounded-none bg-[#E1E3DB40]"
        imageClassName="mix-blend-multiply"
        size="full"
        alt=""
      />
    </LocalizedClientLink>
  );
}
